import React from 'react'
import './index.scss'
import { getDateFromIso } from '@App/helpers/get-date-iso-6801'
import MlcTooltip from '@Components/Tooltips/MlcTooltip'
import clsx from 'clsx'

interface StatusComponentProps {
    status: string
    count?: number
    withCount?: boolean
    date?: string
    big?: boolean
    dateTitle?: string
    tooltip?: string
    circleFirst?: boolean
}

const StatusComponent = (props: StatusComponentProps) => {
    const { status, count, withCount, big, date, dateTitle, tooltip, circleFirst } = props
    const classNames = clsx('status-component', big && 'big', circleFirst && 'circle-first')
    const formattedStatus = status.replace(/\s+|-/g, '')
    const baseCircleId = `base-circle-${formattedStatus}`

    const circleWithTooltip = tooltip ? (
        <>
            <div className={`circle ${formattedStatus.toLowerCase()}`} data-tooltip-id={baseCircleId} />
            <MlcTooltip id={baseCircleId} place="bottom" className="custom-tool-tip-content">
                <span>{tooltip}</span>
            </MlcTooltip>
        </>
    ) : (
        <div className={`circle ${formattedStatus.toLowerCase()}`} />
    )

    return (
        <div className={classNames} data-testid={`status-component-${formattedStatus}`}>
            <div className="status-title">
                {circleFirst && circleWithTooltip}
                <p className="small">
                    {withCount && <span className="status-count bold">{'(' + count + ')'}</span>} {status}
                </p>
                {!circleFirst && circleWithTooltip}
            </div>
            {date && (
                <strong className="small">
                    {dateTitle}&nbsp; {getDateFromIso(date)}
                </strong>
            )}
        </div>
    )
}

export default StatusComponent
